export const ru = {
    ads: {
        one: '{count} объявлениe',
        some: '{count} объявления',
        many: '{count} объявлений',
        none: '{count} объявлений'
    },
    groups: {
        one: '{count} группа',
        some: '{count} группы',
        many: '{count} групп',
        none: '{count} групп'
    },
    keywords: {
        one: '{count} фраза',
        some: '{count} фразы',
        many: '{count} фраз',
        none: '{count} фраз'
    },
    'title-ads': 'Статусы объявлений в группе',
    'title-groups': 'Статусы групп в кампании',
    'title-keywords': 'Статусы фраз в группе'
};
